<div *ngIf="isShow" class="indeterminate">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
